import './fonts';
import './styles.css';

const host = document.querySelector<HTMLElement>('#ui-root');
const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
if (!host || !canvas) throw new Error('Missing #ui-root or #game-canvas.');

const params = new URLSearchParams(location.search);
const uiDevScreen = params.get('uidev');

// UI development harness (worker B): /?uidev=<screen> renders fixture view models only.
// import.meta.glob keeps the build green before/without the harness module.
const uiDevModules = import.meta.glob('./ui/dev.ts');
type UiDevModule = { mountUiDev(host: HTMLElement, screen: string): unknown };

if (params.has('rendertest') && (import.meta.env.DEV || params.has('qa'))) {
  void import('./render/renderTest').then((module) => module.startRenderTest(canvas, host));
} else if (uiDevScreen && (import.meta.env.DEV || params.has('qa')) && uiDevModules['./ui/dev.ts']) {
  void uiDevModules['./ui/dev.ts']().then((module) => (module as UiDevModule).mountUiDev(host, uiDevScreen));
} else {
  const appModules = import.meta.glob('./app/App.ts');
  type AppModule = { startApp(canvas: HTMLCanvasElement, host: HTMLElement): unknown };
  if (appModules['./app/App.ts']) {
    void appModules['./app/App.ts']().then((module) => (module as AppModule).startApp(canvas, host));
  }
}
